import Vue from 'vue';

/**
 * This uses template that is included in script tag
 **/

Vue.component('the-1-column-layout', {
  template: '#js-layout-1-column-template'
});
